import { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { useGraphQLDatas } from '../../components/UserContext'
import { Link, NavLink } from 'react-router-dom'
import moment from 'moment-timezone'

//graphql
import gql from 'graphql-tag'
import { useLazyQuery } from '@apollo/react-hooks'

// images
import logo from '../../../../images/logo.svg'

//styles
import './Home.css'

// semantic ui react
import {
  Container,
  Segment,
  Header,
  Image,
  Message,
  Table,
  Radio,
  Menu,
  Input,
  Icon,
  Button,
  Loader,
  Grid
} from 'semantic-ui-react'


const GET_LOGS = gql`
  query getLogs ($start: Date, $end: Date) {
    me {
      id
      device_consumption (start: $start, end: $end) {
        count
        device {
          id
          name
          serial
          meta
          research
        }
      }
    }
  }
`

const Home = props => {
  // user context
  let { loading, error, data } = useGraphQLDatas()
  // states
  const [me, setMe] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [deviceLogs, setDeviceLogs] = useState()
  const [choose, setChoose] = useState('month')
  // history
  const history = useHistory()
  // set me
  useEffect(() => {
    if (data && !loading && !error && data.me) {
      const { meta, id, username, admin } = data.me
      setMe({ meta, id, username, admin })
    }
  }, [data])

  // set device consumption table
  const [getLogs, { refetch, called, loading: logsLoading }] = useLazyQuery(GET_LOGS, {
    fetchPolicy: 'network-only',
    onCompleted: logsData => {
      if (
        logsData &&
        logsData.me &&
        logsData.me.device_consumption
        ) {
        let logs = logsData.me.device_consumption
        logs = logs.map(log => {
          let { count, device } = log
          let { name, serial, meta, research } = device
          if (research) name = device.name + ' (research)'
          return { count, name, serial }
        })
        setDeviceLogs(logs)
      }
    },
    onError: logsError => {
      console.log(logsError)
    }
  })
  // first load
  useEffect(() => {
    if (me) {
      // obtain logs for this month
      setStartDate(moment().startOf('month'))
      setEndDate(moment().endOf('month'))
    }
  }, [me])

  // obtain device consumption logs
  useEffect(() => {
    if (startDate && endDate) {
      getLogs({
        variables: {
          start: moment(startDate),
          end: moment(endDate)
        }
      })
    }
  }, [startDate, endDate])

  const handleToggleMonth = e => {
    e.preventDefault()
    // reset dates
    if (choose === 'date') {
      // has been on 'date' -> switched to 'month'
      setStartDate(moment().startOf('month'))
      setEndDate(moment().endOf('month'))
    }
    // set monthly / by dates
    setChoose(choose === 'month' ? 'date' : 'month')
  }
  // input change events
  let lowestDate = moment('2021-06-01').startOf('day')

  const handleChangeStart = (e, { value }) => {
    let changedDate = moment(value)
    setStartDate(changedDate)
  }
  const handleChangeEnd = (e, { value }) => {
    let changedDate = moment(value).endOf('day')
    setEndDate(changedDate)
  }
  const handleChangeMonth = (e, { value }) => {
    e.preventDefault()
    let newStart = moment(value).startOf('month')
    let newEnd = moment(value).endOf('month')
    setStartDate(newStart)
    setEndDate(newEnd)
  }
  const handleMinusMonth = e => {
    e.preventDefault()
    let newStart = moment(startDate).subtract(1, 'months')
    let newStartDate = moment(newStart).startOf('month')
    let newEndDate = moment(newStart).endOf('month')
    setStartDate(newStartDate)
    setEndDate(newEndDate)
  }
  const handlePlusMonth = e => {
    e.preventDefault()
    let newStart = moment(startDate).add(1, 'months')
    let newStartDate = moment(newStart).startOf('month')
    let newEndDate = moment(newStart).endOf('month')
    setStartDate(newStartDate)
    setEndDate(newEndDate)
  }
  const handleCreatePDF = e => {
    e.preventDefault()
    history.push({
      pathname: '/pdf',
      state: {
        logs: deviceLogs,
        month: choose === 'month' ? moment(startDate).format('MMMM YYYY') : false,
        date: choose === 'date' ? { start: moment(startDate).format('DD. MMM YYYY'), end: moment(endDate).format('DD. MMM YYYY') } : false
      }
    })
  }

  return (
    <Container className='Home'>
      {/* show message warning to update password */}
      {me && me.meta && !me.meta.updated_password && (
        <Message
          info
          size='mini'
        >
          <Message.Header>Welcome to Munogu <b>{me.username}</b>!</Message.Header>
          <p>Your password is the default one!</p>
          <p>Please change your password on your profile page or <NavLink to={`/users/${me.id}`}><u>Click here</u></NavLink>.</p>
        </Message>
      )}
      <Header as='h3' attached='top'>Welcome to Rehability</Header>
      <Segment attached='bottom' style={{ textAlign: 'center' }}>
        <Image src={logo} centered size='tiny' />
        To start click on Devices page
        <br />
        or <NavLink className='linky' to='/devices'>Click here</NavLink>.
      </Segment>

      {called && logsLoading && (<Loader active>Loading logs...</Loader>)}

      {!logsLoading && deviceLogs && (
        <>
          <Header as='h3'>Device Consumption:</Header>
          <Segment attached='top'>
            <Grid attached='top' columns='equal' container style={{width: '100%'}}>
              <Grid.Column style={{paddingTop: '1.5rem'}} mobile={16} tablet={8} computer={8}>
                <Radio
                  toggle
                  checked={choose === 'month'}
                  onClick={handleToggleMonth}
                />
                &emsp;{choose === 'month' ? 'Monthly' : 'Date Range'}
              </Grid.Column>
              <Grid.Column
                style={choose !== 'month' ? {display: 'none'} : {}}
                mobile={16}
                tablet={8}
                computer={8}
              >
                <Icon
                  style={{cursor: 'pointer'}}
                  name='angle left'
                  size='big'
                  onClick={handleMinusMonth}
                  disabled={startDate && moment(startDate) <= moment(lowestDate)}
                />
                <Input
                  type='month'
                  value={startDate && moment(startDate).format('yyyy-MM')}
                  onChange={handleChangeMonth}
                  min={lowestDate.format('yyyy-MM')}
                  max={moment().endOf('month').add(1, 'months').format('yyyy-MM')}
                />
                <span>&emsp;</span>
                <Icon
                  style={{cursor: 'pointer'}}
                  name='angle right'
                  size='big'
                  onClick={handlePlusMonth}
                  disabled={endDate && moment(endDate) >= moment().add(1, 'months')}
                />
              </Grid.Column>
              <Grid.Column
                style={choose === 'month' ? {display: 'none'} : {}}
                mobile={16}
                tablet={8}
                computer={8}
              >
                From&emsp;
                <Input
                  type='date'
                  value={startDate && moment(startDate).format('yyyy-MM-DD')}
                  onChange={handleChangeStart}
                  min={lowestDate && lowestDate.startOf('day').format('yyyy-MM-DD')}
                  max={endDate && endDate.format('yyyy-MM-DD')}
                />
                <span>&emsp;</span>
                {/* mobile style break */}
                <div className='mobile-break'></div>
                To
                <span>&emsp;</span>
                <Input
                  type='date'
                  value={endDate && moment(endDate).format('yyyy-MM-DD')}
                  onChange={handleChangeEnd}
                  min={startDate && startDate.format('yyyy-MM-DD')}
                  max={moment().endOf('month').add(1, 'months').format('yyyy-MM-DD')}
                />
              </Grid.Column>
            </Grid>
          </Segment>
          <Table celled attached='bottom'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell collapsing>{/* empty field -> count */}</Table.HeaderCell>
                <Table.HeaderCell>Device Name:</Table.HeaderCell>
                <Table.HeaderCell>Device Serial:</Table.HeaderCell>
                <Table.HeaderCell>Used #:</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {deviceLogs && deviceLogs.length > 0 && deviceLogs.map((log, i) => (
                <Table.Row key={i}>
                  <Table.Cell>{i + 1}</Table.Cell>
                  <Table.Cell>{log.name}</Table.Cell>
                  <Table.Cell>{log.serial}</Table.Cell>
                  <Table.Cell>{log.count}</Table.Cell>
                </Table.Row>
              ))}
              {deviceLogs && deviceLogs.length === 0 && (
                <Table.Row key='no logs' >
                  <Table.Cell colSpan='4'
                    style={{textAlign: 'center'}}
                  >
                    No activities for selected period
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
          <Button
            primary
            onClick={handleCreatePDF}
          >
            Create PDF
          </Button>
        </>
      )}
    </Container>
  )
}

export default Home
